<template>
  <lazy-theme7-base-not-found :is-full-screen-error="true" :background-color="vars.backgroundColor">
    <template #title v-if="variants.v1 === variant">
      <div class="tw-items-left tw-flex tw-flex-col tw-px-8 tw-text-left">
        <!-- Sadece mobilde göster -->
        <h3 class="d-block d-md-none tw-mb-6">
          <span class="not-found-title">SORRY, THE PAGE YOU WERE LOOKING FOR WAS </span>
          <span class="not-found-bg tw-rounded-lg tw-bg-yellow-300 tw-px-2 tw-text-black"> NOT FOUND </span>
        </h3>

        <!-- Tablet ve daha büyük ekranlarda göster -->
        <h1 class="d-none d-md-block tw-mb-6 lg:tw-max-w-7xl">
          <span class="not-found-title"> SORRY, THE PAGE YOU WERE LOOKING FOR WAS </span>
          <span class="not-found-bg tw-rounded-lg tw-bg-yellow-300 tw-px-4 tw-py-1 tw-text-black"> NOT FOUND </span>
        </h1>

        <!-- Açıklamalar -->
        <div v-if="descriptions" class="tw-mb-8">
          <p
            v-for="(item, idx) in descriptions"
            :key="`notfound-desc-${idx}`"
            class="not-found-desc tw-mb-2 tw-text-gray-600"
          >
            {{ item.description }}
          </p>
        </div>

        <!-- Buton -->
        <div>
          <nuxt-link :to="vars.buttonLinkUrl" class="n-primary n-btn tw-px-6 tw-py-3 tw-text-lg" :external="true">
            {{ vars.buttonLabelText }}
          </nuxt-link>
        </div>
      </div>
    </template>
    <template #title v-if="variants.v2 === variant">
      <div class="tw-items-left tw-flex tw-flex-col tw-px-8 tw-text-left">
        <div class="v2-title tw-text-start" v-html="vars.statusHtml"></div>
        <div class="tw-w-full tw-text-start">
          <p class="tw-mb-8 tw-mt-4 lg:tw-mb-12">{{ vars.descriptionText }}</p>
          <nuxt-link :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">{{ vars.buttonLabelText }}</nuxt-link>
        </div>
      </div>
    </template>
  </lazy-theme7-base-not-found>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'NotFoundPage',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  setup() {
    const event = useRequestEvent();

    // event will be undefined in the browser
    if (event) {
      // Set the status message as well
      setResponseStatus(event, 404, 'Page Not Found');
    }
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>
